import { dew as _dropTransactionDew } from "../../actions/test/dropTransaction.js";
import { dew as _dumpStateDew } from "../../actions/test/dumpState.js";
import { dew as _getAutomineDew } from "../../actions/test/getAutomine.js";
import { dew as _getTxpoolContentDew } from "../../actions/test/getTxpoolContent.js";
import { dew as _getTxpoolStatusDew } from "../../actions/test/getTxpoolStatus.js";
import { dew as _impersonateAccountDew } from "../../actions/test/impersonateAccount.js";
import { dew as _increaseTimeDew } from "../../actions/test/increaseTime.js";
import { dew as _inspectTxpoolDew } from "../../actions/test/inspectTxpool.js";
import { dew as _loadStateDew } from "../../actions/test/loadState.js";
import { dew as _mineDew } from "../../actions/test/mine.js";
import { dew as _removeBlockTimestampIntervalDew } from "../../actions/test/removeBlockTimestampInterval.js";
import { dew as _resetDew } from "../../actions/test/reset.js";
import { dew as _revertDew } from "../../actions/test/revert.js";
import { dew as _sendUnsignedTransactionDew } from "../../actions/test/sendUnsignedTransaction.js";
import { dew as _setAutomineDew } from "../../actions/test/setAutomine.js";
import { dew as _setBalanceDew } from "../../actions/test/setBalance.js";
import { dew as _setBlockGasLimitDew } from "../../actions/test/setBlockGasLimit.js";
import { dew as _setBlockTimestampIntervalDew } from "../../actions/test/setBlockTimestampInterval.js";
import { dew as _setCodeDew } from "../../actions/test/setCode.js";
import { dew as _setCoinbaseDew } from "../../actions/test/setCoinbase.js";
import { dew as _setIntervalMiningDew } from "../../actions/test/setIntervalMining.js";
import { dew as _setLoggingEnabledDew } from "../../actions/test/setLoggingEnabled.js";
import { dew as _setMinGasPriceDew } from "../../actions/test/setMinGasPrice.js";
import { dew as _setNextBlockBaseFeePerGasDew } from "../../actions/test/setNextBlockBaseFeePerGas.js";
import { dew as _setNextBlockTimestampDew } from "../../actions/test/setNextBlockTimestamp.js";
import { dew as _setNonceDew } from "../../actions/test/setNonce.js";
import { dew as _setRpcUrlDew } from "../../actions/test/setRpcUrl.js";
import { dew as _setStorageAtDew } from "../../actions/test/setStorageAt.js";
import { dew as _snapshotDew } from "../../actions/test/snapshot.js";
import { dew as _stopImpersonatingAccountDew } from "../../actions/test/stopImpersonatingAccount.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.testActions = void 0;
  const dropTransaction_js_1 = _dropTransactionDew();
  const dumpState_js_1 = _dumpStateDew();
  const getAutomine_js_1 = _getAutomineDew();
  const getTxpoolContent_js_1 = _getTxpoolContentDew();
  const getTxpoolStatus_js_1 = _getTxpoolStatusDew();
  const impersonateAccount_js_1 = _impersonateAccountDew();
  const increaseTime_js_1 = _increaseTimeDew();
  const inspectTxpool_js_1 = _inspectTxpoolDew();
  const loadState_js_1 = _loadStateDew();
  const mine_js_1 = _mineDew();
  const removeBlockTimestampInterval_js_1 = _removeBlockTimestampIntervalDew();
  const reset_js_1 = _resetDew();
  const revert_js_1 = _revertDew();
  const sendUnsignedTransaction_js_1 = _sendUnsignedTransactionDew();
  const setAutomine_js_1 = _setAutomineDew();
  const setBalance_js_1 = _setBalanceDew();
  const setBlockGasLimit_js_1 = _setBlockGasLimitDew();
  const setBlockTimestampInterval_js_1 = _setBlockTimestampIntervalDew();
  const setCode_js_1 = _setCodeDew();
  const setCoinbase_js_1 = _setCoinbaseDew();
  const setIntervalMining_js_1 = _setIntervalMiningDew();
  const setLoggingEnabled_js_1 = _setLoggingEnabledDew();
  const setMinGasPrice_js_1 = _setMinGasPriceDew();
  const setNextBlockBaseFeePerGas_js_1 = _setNextBlockBaseFeePerGasDew();
  const setNextBlockTimestamp_js_1 = _setNextBlockTimestampDew();
  const setNonce_js_1 = _setNonceDew();
  const setRpcUrl_js_1 = _setRpcUrlDew();
  const setStorageAt_js_1 = _setStorageAtDew();
  const snapshot_js_1 = _snapshotDew();
  const stopImpersonatingAccount_js_1 = _stopImpersonatingAccountDew();
  function testActions({
    mode
  }) {
    return client_ => {
      const client = client_.extend(() => ({
        mode
      }));
      return {
        dropTransaction: args => (0, dropTransaction_js_1.dropTransaction)(client, args),
        dumpState: () => (0, dumpState_js_1.dumpState)(client),
        getAutomine: () => (0, getAutomine_js_1.getAutomine)(client),
        getTxpoolContent: () => (0, getTxpoolContent_js_1.getTxpoolContent)(client),
        getTxpoolStatus: () => (0, getTxpoolStatus_js_1.getTxpoolStatus)(client),
        impersonateAccount: args => (0, impersonateAccount_js_1.impersonateAccount)(client, args),
        increaseTime: args => (0, increaseTime_js_1.increaseTime)(client, args),
        inspectTxpool: () => (0, inspectTxpool_js_1.inspectTxpool)(client),
        loadState: args => (0, loadState_js_1.loadState)(client, args),
        mine: args => (0, mine_js_1.mine)(client, args),
        removeBlockTimestampInterval: () => (0, removeBlockTimestampInterval_js_1.removeBlockTimestampInterval)(client),
        reset: args => (0, reset_js_1.reset)(client, args),
        revert: args => (0, revert_js_1.revert)(client, args),
        sendUnsignedTransaction: args => (0, sendUnsignedTransaction_js_1.sendUnsignedTransaction)(client, args),
        setAutomine: args => (0, setAutomine_js_1.setAutomine)(client, args),
        setBalance: args => (0, setBalance_js_1.setBalance)(client, args),
        setBlockGasLimit: args => (0, setBlockGasLimit_js_1.setBlockGasLimit)(client, args),
        setBlockTimestampInterval: args => (0, setBlockTimestampInterval_js_1.setBlockTimestampInterval)(client, args),
        setCode: args => (0, setCode_js_1.setCode)(client, args),
        setCoinbase: args => (0, setCoinbase_js_1.setCoinbase)(client, args),
        setIntervalMining: args => (0, setIntervalMining_js_1.setIntervalMining)(client, args),
        setLoggingEnabled: args => (0, setLoggingEnabled_js_1.setLoggingEnabled)(client, args),
        setMinGasPrice: args => (0, setMinGasPrice_js_1.setMinGasPrice)(client, args),
        setNextBlockBaseFeePerGas: args => (0, setNextBlockBaseFeePerGas_js_1.setNextBlockBaseFeePerGas)(client, args),
        setNextBlockTimestamp: args => (0, setNextBlockTimestamp_js_1.setNextBlockTimestamp)(client, args),
        setNonce: args => (0, setNonce_js_1.setNonce)(client, args),
        setRpcUrl: args => (0, setRpcUrl_js_1.setRpcUrl)(client, args),
        setStorageAt: args => (0, setStorageAt_js_1.setStorageAt)(client, args),
        snapshot: () => (0, snapshot_js_1.snapshot)(client),
        stopImpersonatingAccount: args => (0, stopImpersonatingAccount_js_1.stopImpersonatingAccount)(client, args)
      };
    };
  }
  exports.testActions = testActions;
  //# sourceMappingURL=test.js.map
  return exports;
}